import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { SummaryStatusResponse } from '../../../models/round-summary.model';

@Component({
  selector: 'app-match-day-summary-modal',
  templateUrl: './match-day-summary-modal.component.html',
  styleUrls: ['./match-day-summary-modal.component.scss'],
  standalone: false,
})
export class MatchDaySummaryModalComponent {
  constructor(
    public sheetRef: MatBottomSheetRef<MatchDaySummaryModalComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public summary: SummaryStatusResponse,
  ) {}

  close(): void {
    this.sheetRef.dismiss();
  }
}
